import React from 'react';

import ClosedEyeIcon from '@/shared/assets/closed_eye_icon.svg?react';
import InternalIcon from '@/shared/assets/internal_icon.svg?react';
import OpenEyeIcon from '@/shared/assets/opened_eye_icon.svg?react';
import { Gradients } from '@/shared/components/theme/gradient';
import RoundedIcon from '@/shared/components/ui/rounded-icon';
import { DocumentVisibility } from '@/shared/components/ui/upload/document-upload-dialog';

const VisbilityIndicator = ({
  visibility,
  showRawIcon,
}: {
  visibility: DocumentVisibility;
  showRawIcon?: boolean;
}) => {
  const icon = React.createElement(() => {
    switch (visibility) {
      case 'private':
        return <ClosedEyeIcon className="h-6 w-6" />;
      case 'internal':
        return <InternalIcon className="h-6 w-6" />;
      case 'public':
      default:
        return <OpenEyeIcon className="h-6 w-6" />;
    }
  });

  if (showRawIcon) {
    return icon;
  }

  return <RoundedIcon icon={icon} bgColor={Gradients.purpleBlueGradient} />;
};

export default VisbilityIndicator;
